module.exports = __webpack_public_path__ + "static/media/collection-lot-favorite.f5db95f4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/collection-lot-favorite.svg
// module id = 1552
// module chunks = 0